import img1 from "../assets/img/img1.jpg";
import img2 from "../assets/img/img2.jpg";
import img3 from "../assets/img/img3.jpg";
import img10 from "../assets/img/img10.jpg";
import img11 from "../assets/img/img11.jpg";
import img12 from "../assets/img/img12.jpg";

const images = [img1, img2, img3, img10, img11, img12];

const seedPosts = [
  {
    title: "13F 데이터에서 진짜 시그널만 추리는 방법",
    summary: "대형 투자자의 포지션 변화를 ‘보유 수량’만 보고 판단하면 놓치는 신호가 많습니다.",
    category: "인사이트"
  },
  {
    title: "실적 시즌에 유효한 뉴스 필터링 기준",
    summary: "뉴스량이 폭증하는 구간에서 사실 기반 신호만 추리는 기준을 정리했습니다.",
    category: "뉴스"
  },
  {
    title: "티커 검색 UX를 개선하는 3가지 원칙",
    summary: "검색 속도와 정확도, 그리고 사용자의 다음 행동까지 고려한 설계 팁입니다.",
    category: "제품"
  },
  {
    title: "내부자 거래 데이터로 보는 매수 타이밍",
    summary: "Form 4 기반의 실전 패턴을 요약하고, 실적 전후의 변화를 비교합니다.",
    category: "인사이더"
  },
  {
    title: "트렌드 큐레이션은 어떻게 만들어지는가",
    summary: "공시, 보유 변화, 뉴스 메타데이터를 한 화면에 묶는 큐레이션 로직을 소개합니다.",
    category: "트렌드"
  },
  {
    title: "API 레이트리밋을 설계할 때 고려할 것",
    summary: "서비스 안정성과 고객 경험 사이의 균형을 맞추는 레이트리밋 설계 가이드입니다.",
    category: "API"
  },
  {
    title: "기업 메타 정보 품질을 높이는 데이터 파이프라인",
    summary: "회사명/티커/거래소 데이터를 정규화해 검색 정확도를 높이는 방법입니다.",
    category: "데이터"
  },
  {
    title: "포트폴리오에서 통계적 유의성을 찾는 법",
    summary: "보유 비중, 회전율, 분산 정보를 통해 신뢰도 높은 시그널을 찾습니다.",
    category: "인사이트"
  },
  {
    title: "프론트엔드 성능 최적화 체크리스트",
    summary: "리스트, 차트, 이미지가 많은 화면을 빠르게 만드는 기본 세팅을 정리했습니다.",
    category: "제품"
  },
  {
    title: "대량 뉴스 요약을 위한 텍스트 파이프라인",
    summary: "키워드 추출부터 요약 생성까지, 뉴스 처리 흐름을 단계별로 소개합니다.",
    category: "뉴스"
  },
  {
    title: "투자 대가의 매수/매도 신호를 분리하는 기준",
    summary: "단순 보유 변화가 아닌 ‘의도’를 구분하는 기준을 사례로 설명합니다.",
    category: "인사이트"
  },
  {
    title: "API 키 관리와 보안 운영 실무",
    summary: "키 발급, 회전, 폐기까지 실제 운영 환경에서 필요한 체크포인트입니다.",
    category: "API"
  },
  {
    title: "실적 발표 후 주가 반응을 해석하는 법",
    summary: "수치 발표보다 ‘예상치와의 거리’가 중요한 이유를 설명합니다.",
    category: "리서치"
  },
  {
    title: "커스텀 데이터 연동 시 가장 많이 묻는 질문",
    summary: "내부 데이터와 외부 데이터를 결합할 때의 문제와 해결책을 다룹니다.",
    category: "데이터"
  },
  {
    title: "대시보드에서 가장 읽히는 카드 구성",
    summary: "사용자의 첫 시선을 잡는 카드 정보 구조를 정리했습니다.",
    category: "제품"
  },
  {
    title: "공시 이벤트 타이밍을 예측하는 힌트",
    summary: "과거 패턴과 주기성을 이용해 공시 집중 구간을 예측합니다.",
    category: "리서치"
  },
  {
    title: "기업 뉴스 분류를 자동화하는 기준",
    summary: "카테고리 분류 기준을 통일해 뉴스 탐색 시간을 줄입니다.",
    category: "뉴스"
  },
  {
    title: "원문 공시에서 핵심 문장만 뽑아내기",
    summary: "긴 공시문을 빠르게 파악할 수 있는 요약 기준을 소개합니다.",
    category: "인사이더"
  }
];

const formatDate = (index) => {
  const baseDay = 5 + index;
  const day = String(baseDay).padStart(2, "0");
  return `2025-01-${day}`;
};

const blogPosts = seedPosts.map((post, index) => ({
  id: index + 1,
  title: post.title,
  summary: post.summary,
  category: post.category,
  date: formatDate(index),
  readingTime: 4 + (index % 4),
  author: "GuruWhisper Lab",
  image: images[index % images.length]
}));

export default blogPosts;
